import { AxiosInstance } from 'axios';
import { AvailableUserThemes, DefaultUserThemes, FeaturedThemeSet } from 'referral-types';
import { simulate } from './utils';
import { SITE_URL } from './service';
import { Size } from '../constants';
import { ThemeType } from '../components/page/settings-panel/constants';

export const baseEndpoint = 'theme';

export class ThemeApi {
  private apiInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getThemesForUser(): Promise<AvailableUserThemes> {
    await simulate();
    const response = await this.apiInstance.get(`/`);

    return response.data;
  }

  async getBasicThemes(): Promise<DefaultUserThemes> {
    await simulate();

    const response = await this.apiInstance.get(`/basic`);

    return response.data;
  }


  async getFeaturedThemes(): Promise<Array<FeaturedThemeSet>> {
    await simulate();

    const response = await this.apiInstance.get(`/featured`);

    return response.data;
  }

  getBackgroundImageSrc(themeId: string, size: Size, subThemeId?: string): string {
    return `${SITE_URL}/image/background-theme/${themeId}?size=${size}${subThemeId ? `&subThemeId=${subThemeId}` : ''}`;
  }

  getBackgroundThemePresetSrc(themeId: string, subThemeId?: string): string {
    return `${SITE_URL}/image/background-theme/${themeId}/preset${subThemeId ? `?subThemeId=${subThemeId}` : ''}`;
  }
}
